import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import ContextProductProvider from "./context/contextproduct/ContextProductProvider";
import ThemeProvider from "./context/theme/ThemeProvider";
import NavBar from "./component/navbar/NavBar";
import Footer from "./component/footer/Footer";
import Loader from "./component/loader/Loader";

const Home = lazy(() => import("./component/home/Home"));
const Products = lazy(() => import("./component/product/Products"));
const ProductDetails = lazy(
  () => import("./component/productDetails/ProductDetails"),
);
const Cart = lazy(() => import("./component/cart/Cart"));

function App() {
  return (
    <ThemeProvider>
      <ContextProductProvider>
        <Router>
          <div
            style={{
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <NavBar />
            <main style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <Suspense fallback={<Loader />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:id" element={<ProductDetails />} />
                  <Route path="/cart" element={<Cart />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
          </div>
        </Router>
      </ContextProductProvider>
    </ThemeProvider>
  );
}

export default App;
